import classes from "@/styles/fulfilment-partners/tforce.module.css";
import { tForce } from "@/utils/content";
import Image from "next/image";
import { FaDotCircle, FaTruck } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import { GiEarthAmerica } from "react-icons/gi";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import Link from "next/link";
import { useState } from "react";
import IntegrationDetails from "../partners/integration-details";
import { logo, smallLogo } from "@/utils/images";
import { AiOutlinePlus } from "react-icons/ai";
import { useIsMobile } from "@/hooks/useIsMobile";

export default function TForceMain() {
  const isMobile = useIsMobile();

  const content = tForce.en;

  const [open, setOpen] = useState<string>("1");

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <main className={classes.container}>
      <section className={classes.hero}>
        <Container>
          <div className={classes.heroGrid}>
            <Image
              // className={classes.heroLogo}
              className={`${isMobile ? "me-4" : "ms-5"} img-fluid`}
              src={isMobile ? smallLogo : logo}
              alt={logo}
              height={80}
              width={isMobile ? 80 : 300}
            />
            <AiOutlinePlus size={40} />
            <Image
              className={`${classes.heroImg} img-fluid`}
              src={content.hero.img1}
              alt={content.hero.img1}
              height={150}
              width={250}
            />
          </div>
        </Container>
      </section>
      {/* section1 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={7}>
            <p className="fw-bold">{content.section1.note}</p>
            <h3>{content.section1.title}</h3>
            <p>{content.section1.para}</p>
          </Col>
          <Col xs={12} lg={5}></Col>
        </Row>
      </section>
      {/* section2 */}
      <section className="my-5 container">
        <Row>
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={12}
            lg={7}
          >
            <div>
              <h3>{content.section2.title}</h3>
              <p>{content.section2.para}</p>
            </div>
          </Col>
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={12}
            lg={5}
          >
            <Image
              src={content.section2.img1}
              alt={content.section2.img1}
              height={300}
              width={400}
            />
          </Col>
        </Row>
      </section>
      {/* section3 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={3}>
            {content.section3.list2.map((l, i) => {
              return (
                <div className="d-flex align-items-center my-4" key={i}>
                  <div className={classes.icoWrapper}>
                    {i === 0 && (
                      <FaDotCircle className={classes.ico} size={20} />
                    )}
                    {i === 1 && (
                      <BiCurrentLocation className={classes.ico} size={20} />
                    )}
                    {i === 2 && (
                      <GiEarthAmerica className={classes.ico} size={20} />
                    )}
                    {i === 3 && <FaTruck className={classes.ico} size={20} />}
                  </div>
                  <p className="w-50 ps-3 m-0">{l}</p>
                </div>
              );
            })}
            <p>{content.section3.disclaimer}</p>
          </Col>
          <Col xs={12} lg={9}>
            <h3>{content.section3.title}</h3>
            <p>{content.section3.para}</p>
            <ul>
              {content.section3.list.map((l, i) => {
                return (
                  <li className="my-1" key={i}>
                    <span className="fw-bold">{l.title}&nbsp;</span>
                    <span>{l.desc}</span>
                  </li>
                );
              })}
            </ul>
            <p>{content.section3.note}</p>
          </Col>
        </Row>
      </section>
        {/* section3a */}
        <section className="my-5 container">
        <Row>
          <Col xs={12} lg={9}>
            <h3>{content.section3a.title}</h3>
            <p>{content.section3a.para}</p>
            <ul>
              {content.section3a.list.map((l, i) => {
                return (
                  <li className="my-1" key={i}>
                    <span className="fw-bold">{l.title}&nbsp;</span>
                    <span>{l.desc}</span>
                  </li>
                );
              })}
            </ul>
            <p>{content.section3.note}</p>
          </Col>
          <Col xs={12} lg={3}>
          <Image
              className={`${classes.section3aImg} img-fluid`}
              src={content.section3a.img1}
              alt={content.section3a.alt1}
              height={150}
              width={250}
            />
          </Col>
        </Row>
      </section>
      {/* section4 */}
      <section className="my-5 container">
        <Card className={classes.cardBg}>
          <CardBody className="p-5">
            <div className="text-center">
              <h3>{content.section4.title}</h3>
              <p>{content.section4.para}</p>
            </div>
            <Row>
              {content.section4.services.map((s, i) => {
                return (
                  <Col xs={12} lg={4} key={i}>
                    <Link className="my-3 d-block" href={`/partners${s.link}`}>
                      <Card className={classes.serviceCard}>
                        <CardBody className="text-white">
                          <h5>{s.title}</h5>
                          <p>{s.desc}</p>
                        </CardBody>
                      </Card>
                    </Link>
                  </Col>
                );
              })}
            </Row>
          </CardBody>
        </Card>
      </section>
      {/* section6 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={3}>
            <h3>{content.section5.title}</h3>
            <p>{content.section5.para}</p>
          </Col>
          <Col xs={12} lg={9}>
            {/*@ts-ignore*/}
            <Accordion open={open} toggle={toggle}>
              {content.section5?.faqs?.map((f, i) => {
                return (
                  <AccordionItem key={i}>
                    <AccordionHeader targetId={(i + 1).toString()}>
                      {f.title}
                    </AccordionHeader>
                    <AccordionBody accordionId={(i + 1).toString()}>
                      <p>{f.desc}</p>
                    </AccordionBody>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </Col>
        </Row>
      </section>
      {/* section6 */}
      {/* <section className="my-5 container">
        <h3>{content.section6.title}</h3>
        <IntegrationDetails partnerDetails={content} />
      </section> */}
    </main>
  );
}
